// app/javascript/components/Chat/AccountMenuContent.js
import * as React from "react";
import { Box, Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { themeColors } from "../../utils/constants";
import { allowPuertaWeb } from "../../pages/Admin/utils";
import { useChatContext } from "../../contexts/ChatContext";

export function AccountMenuLink({ href, children, ...props }) {
  return (
    <MenuItem
      component="a"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-account-menu-link="true"
      {...props}
    >
      {children}
    </MenuItem>
  );
}

export default function AccountMenuContent({ anchorEl, open, onClose, appProps }) {
  const navigate = useNavigate();
  const isLoggedIn = !!appProps?.userData?.user_id;
  const { resetChatState } = useChatContext();

  const handleLogout = async (event) => {
    event?.preventDefault?.();
    try {
      const res = await fetch("/logout", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      const data = await res.json();
      if (data.error_message) {
        appProps.setErrors?.(data.error_message);
      } else {
        navigate("/chat");
        resetChatState();
        appProps.clearStateData?.();
      }
    } catch (error) {
      console.log("api errors:", error);
    } finally {
      onClose?.();
    }
  };

  return (
    <Menu
      anchorEl={anchorEl}
      id="account-menu-shared"
      open={open}
      onClose={onClose}
      onClick={onClose}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
          // mt: 1.5,
          ml: 1,
          mb: 1.5,
          backgroundColor: themeColors.chatBoxColor,
          color: themeColors.color,
          "& .MuiAvatar-root": { width: 32, height: 32, ml: -0.5, mr: 1 },
          "&:before": {
            content: '""',
            display: "block",
            position: "absolute",
            left: 0,
            width: 10,
            height: 10,
            bottom: 10,
            bgcolor: themeColors.chatBoxColor,
            transform: "translate(-50%, -50%) rotate(45deg)",
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: "left",  vertical: "center" }}
      anchorOrigin={{    horizontal: "right", vertical: "center" }}
    >
      {isLoggedIn ? (
        <Box>
          {appProps.userData && allowPuertaWeb(appProps.userData) && (
            <AccountMenuLink href="/puerta-web">
              Puerta Web
            </AccountMenuLink>
          )}

          <AccountMenuLink href="/account">
            Account
          </AccountMenuLink>

          {/* <MenuItem
            onClick={async () => {
              const ok = window.confirm("Are you sure you want to clear your user memory?");
              if (!ok) return;
              try {
                const result = await clearUserMemory();
                if (result?.status === "200") {
                  alert("User memory cleared successfully!");
                } else {
                  alert("Failed to clear user memory.");
                }
              } catch (err) {
                console.error(err);
                alert("An error occurred while clearing memory.");
              } finally {
                onClose();
              }
            }}
          >
            Clear User Memory
          </MenuItem> */}

          <AccountMenuLink href="https://www.inciteai.com/learn-more">
            Learn More
          </AccountMenuLink>

          <AccountMenuLink href="https://inciteai.com">
            Website
          </AccountMenuLink>

          <AccountMenuLink href="/terms-of-use">
            Terms of Use
          </AccountMenuLink>

          <AccountMenuLink href="/privacy-policy">
            Privacy Policy
          </AccountMenuLink>

          <AccountMenuLink href="/feedback">
            Feedback
          </AccountMenuLink>

          <AccountMenuLink href="https://www.inciteai.com/contact">
            Contact
          </AccountMenuLink>

          <MenuItem onClick={handleLogout}>Log out</MenuItem>
        </Box>
      ) : (
        <Box>
          <AccountMenuLink
            href="/register"
            onClick={() => {
              appProps.setUserData?.({ ...appProps.userData, uuidHasAccount: true });
            }}
          >
            Log In
          </AccountMenuLink>

          <AccountMenuLink href="https://www.inciteai.com/learn-more">
            Learn More
          </AccountMenuLink>

          <AccountMenuLink href="https://inciteai.com">
            Website
          </AccountMenuLink>

          <AccountMenuLink href="https://inciteai.com/terms-and-conditions">
            Terms and Conditions
          </AccountMenuLink>

          <AccountMenuLink href="https://inciteai.com/privacy-policy">
            Privacy Policy
          </AccountMenuLink>

          <AccountMenuLink href="/feedback">
            Feedback
          </AccountMenuLink>

          <AccountMenuLink href="https://www.inciteai.com/contact">
            Contact
          </AccountMenuLink>
        </Box>
      )}
    </Menu>
  );
}
